import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './Calendar.css';

const SingleDatePicker = ({ value, onChange, minDate, className, placeholderText }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [tempDate, setTempDate] = useState(value ? new Date(value) : null);

  // Sync tempDate with value prop when it changes
  useEffect(() => {
    setTempDate(value ? new Date(value) : null);
  }, [value]);

  // Handle calendar date selection
  const handleDateSelect = (date) => {
    setTempDate(date);
  };

  // Apply the selected date
  const handleApply = () => {
    if (tempDate && onChange) {
      onChange(tempDate); // Update parent state
    }
    setIsPopupOpen(false);
  };

  // Cancel and reset to initial value
  const handleCancel = () => {
    setTempDate(value ? new Date(value) : null);
    setIsPopupOpen(false);
  };

  // Format date for display as "Month Day Year" (e.g., April 17 2025)
  const formatDate = (date) => {
    if (!date || isNaN(new Date(date))) return '';
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    }); // Format as April 17 2025
  };

  // Tile class for highlighting selected date
  const tileClassName = ({ date, view }) => {
    if (view === 'month' && tempDate) {
      if (date.toDateString() === tempDate.toDateString()) {
        return 'highlight-selected';
      }
    }
    return '';
  };

  return (
    <div className="relative">
      {/* Date Input Field */}
      <input
        type="text"
        value={formatDate(value)}
        onClick={() => setIsPopupOpen(true)}
        readOnly
        placeholder={placeholderText || 'Select Date'}
        className={`w-full px-4 py-2 border border-gray-300 h-[44px] rounded-lg bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${className || ''}`}
      />

      {/* Calendar Popup */}
      {isPopupOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={handleCancel}
        >
          <div
            className="bg-white p-4 rounded-lg shadow-lg max-w-md w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              value={tempDate || new Date()}
              onClickDay={handleDateSelect}
              tileClassName={tileClassName}
              minDate={minDate}
              className="w-full border-none"
              navigationLabel={({ date }) =>
                date.toLocaleString('default', { month: 'long', year: 'numeric' })
              }
              minDetail="month"
              maxDetail="month"
              showNeighboringMonth={false}
              next2Label={null}
              prev2Label={null}
            />
            <div className="mt-4 flex justify-end gap-2">
              <button
                className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 text-sm"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800 text-sm"
                onClick={handleApply}
                disabled={!tempDate || isNaN(new Date(tempDate))}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleDatePicker;